/**
 * section-main-cart.js
 * AJAX cart page — qty +/-, remove, note save.
 * Updates DOM in-place without page reload.
 */
(function () {
  'use strict';

  var section = document.getElementById('cart-page-section');
  if (!section) return;

  function money(cents) {
    var val = (cents / 100).toFixed(2);
    return '$' + val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var _noteTimer = null;

  function setItemLoading(row, on) {
    if (!row) return;
    row.style.opacity = on ? '0.5' : '';
    row.style.pointerEvents = on ? 'none' : '';
  }

  function changeItem(key, qty, row) {
    setItemLoading(row, true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      syncBadges(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      return cart;
    })
    .catch(function () {})
    .finally(function () { setItemLoading(row, false); });
  }

  function renderCart(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    var countEl = section.querySelector('[data-cart-page-count]');
    if (countEl) {
      countEl.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')';
    }

    section.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    section.querySelectorAll('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });

    var rows = section.querySelectorAll('[data-cart-item]');
    rows.forEach(function (row) {
      var key = row.dataset.itemKey;
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }

      if (!item) {
        row.style.transition = 'opacity 0.3s ease, max-height 0.3s ease';
        row.style.opacity = '0';
        row.style.maxHeight = row.offsetHeight + 'px';
        row.style.overflow = 'hidden';
        setTimeout(function () {
          row.style.maxHeight = '0';
          row.style.padding = '0';
          row.style.margin = '0';
          row.style.borderBottom = 'none';
        }, 10);
        setTimeout(function () { row.remove(); }, 350);
        return;
      }

      var qtyInput = row.querySelector('[data-qty-input]');
      if (qtyInput && parseInt(qtyInput.value, 10) !== item.quantity) {
        qtyInput.value = item.quantity;
      }

      var totalEl = row.querySelector('[data-item-total]');
      if (totalEl) totalEl.textContent = money(item.final_line_price);
    });
  }

  function syncBadges(count) {
    document.querySelectorAll('.nav__cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  section.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var row = qtyBtn.closest('[data-cart-item]');
      if (!row) return;
      var input = row.querySelector('[data-qty-input]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var delta = parseInt(qtyBtn.dataset.qtyChange, 10);
      var newQty = Math.max(0, current + delta);
      input.value = newQty;
      changeItem(row.dataset.itemKey, newQty, row);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      var rmRow = removeBtn.closest('[data-cart-item]');
      changeItem(removeBtn.dataset.removeKey, 0, rmRow);
      return;
    }
  });

  section.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var row = input.closest('[data-cart-item]');
    if (!row) return;
    var newQty = Math.max(0, parseInt(input.value, 10) || 0);
    changeItem(row.dataset.itemKey, newQty, row);
  });

  var noteEl = section.querySelector('[data-cart-note]');
  if (noteEl) {
    noteEl.addEventListener('input', function () {
      clearTimeout(_noteTimer);
      _noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        }).catch(function () {});
      }, 500);
    });
  }

  var form = section.querySelector('#cart-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') return;
      e.preventDefault();
    });
  }
})();
